import { createSelector } from 'reselect';
export const getUpdatePasswordError = state => state.errors.get('updatePassword');
export const getUpdatePasswordErrorMessage = createSelector([getUpdatePasswordError], updatePasswordError => {
  return updatePasswordError ? updatePasswordError.get('message') : undefined;
});
export const getUnrecoverableErrors = state => state.errors.get('unrecoverableErrors');
export const getPhoneValidation = state => state.errors.get('phoneValidation');
export const getDeletePhoneError = state => state.errors.get('deleteNumberError');
export const getDeletePasskeyError = state => state.errors.get('deletePasskeyError');
export const getRenamePasskeyError = state => state.errors.get('renamePasskeyError');